const adminEmails = ['przmld033@gmail.com', 'business@affbar.net', 'affbarmediagroup@gmail.com'];

export default adminEmails;
